<template>
<div>
  <div class="recruit">
    <div class="box" v-bind:style="background">
      <Title :title="title" :message="message"/>
    </div>
    <div class="news">
      <div class="news_title">
        <h1>採用News</h1>
      </div>
      <div class="news_contents">
        <p class="day">2025/1</p>
        <p class="contents">2026年新卒応募を開始しました。観光部門、貨物部門でそれぞれ募集いたします。</p>
      </div>
    </div>
    <div class="works">
      <div class="works_title">
        <h1>仕事紹介</h1>
      </div>
      <div class="works_note">
        <iframe class="note-embed" src="https://note.com/embed/notes/ndb3d0300dfac"></iframe>
        <iframe class="note-embed" src="https://note.com/embed/notes/n306d5d35ae0b"></iframe>
        <iframe class="note-embed" src="https://note.com/embed/notes/na7b19c70c4f6"></iframe>
      </div>
      <div class="pamphlet">
        <p>会社紹介パンフレットには社員の一日なども掲載しています。こちらも合わせてご覧ください。</p>
          <a href="https://drive.google.com/file/d/1mJ_dP5jkUMeLLQGoNwjHaEuHzUIymd9I/view?usp=sharing" class="box5">
            <p>パンフレットのダウンロード</p>
            <div class="arrow01"></div>
          </a>
      </div>
    </div>
    <div class="table_container">
      <div class="table_title">募集要項</div>
      <table class="table">
        <tbody>
          <tr>
            <th>職種</th>
            <td>【総合職】<br>1．貨物部<br>2．観光バス部</td>
          </tr>
          <tr>
            <th>給与</th>
            <td>大卒 220,000円（2020年4月実績）<br>※ 既卒者は最終学歴により上記と同額を支給<br>固定残業代含む 14時間分18,172円（超過した場合、当該時間分を別途支給）</td>
          </tr>
          <tr>
            <th>休日・休暇</th>
            <td>週休二日制（土日出勤有）<br>法定年次休暇・夏季休暇・年末年始休暇・慶弔休暇</td>
          </tr>
          <tr>
              <th>昇給</th>
              <td>年2回（4月・10月）</td>
          </tr>
          <tr>
              <th>賞与</th>
              <td>年2回（6月又は7月・12月）</td>
            </tr>
            <tr>
              <th>福利厚生・手当</th>
              <td>出産・育児休業（2024年実績3名）<br>独身寮（通勤できない場合のみ・一部自己負担）<br>通勤手当・住宅手当・職務手当・時間外手当</td>
            </tr>
            <tr>
              <th>社会保険</th>
              <td>健康保険・厚生年金保険・雇用保険・労災保険</td>
            </tr>
            <tr>
            <th>資格取得制度</th>
            <td>旅行業務取扱管理者資格<br>運行管理者資格<br>国内旅程管理主任者資格<br>大型二種免許（運転士志望のみ）</td>
            </tr>
            <tr>
              <th>勤務時間</th>
              <td>9：00～18：00（休憩1時間、実質8時間）<br>※ 営業所により8：30～17：30<br>※ 車両乗務員は仕業による</td>
            </tr>
            <tr>
              <th>勤務地</th>
              <td>【貨物・工事部】<br>さいたま第一営業所（さいたま市岩槻区）<br> <br>【観光バス部】<br>東京営業所（東京都板橋区）<br>さいたま第二営業所（さいたま市岩槻区）<br>横浜営業所（横浜市港北区）</td>
            </tr>
        </tbody>
      </table>
    </div>
    <div class="entry">
      <div class="entry-title">
      </div>
      <div class="entry-contents">
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Title from '@/components/Title.vue'

export default {
  components: {
    Title
  },
  data () {
    return {
      background: {
        background: '',
        position: 'relative',
        height: '100vh',
        minHeight: '300px',
        backgroundSize: 'cover',

        display: 'flex',
        flexDirection: 'column',

        letterSpacing: '0',
        color: '#FFFFFF'
      },
      title: 'NEW GRAD',
      message: '次の景色を見に行こう'
    }
  },
  created () {
    this.background.background = "url('" + require('../assets/recruit-content.jpg') + "') no-repeat 15% 50%"
  }
}
</script>

<style scoped>
.recruit {
  overflow:hidden;
}
.news{
  padding:2% 4% 4% 4%;
}
h1 {
  font-size:32px;
  font-weight:bold;
  padding:20px 15px;
  margin:0px;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
  color:#000000;
}
.news_contents {
  padding:10px 15px;
  border-bottom-style:solid;
  border-bottom-width:1px;
  border-bottom-color:#a6a6a6;
  display:flex;
  margin:0;
}
.day {
  font-size:16px;
  font-weight:bold;
  padding-right:20px;
}
.contents {
  font-size:16px;
}
.works {
  padding:2% 4% 4% 4%;
  color:#303030;
}
.works_note {
  padding: 20px 0;
}
.note-embed {
  border: 1px solid #2cb696;
  display: inline;
  max-width: 99%;
  width: 389px;
  padding: 0px;
  margin: 10px;
  position: static;
  visibility: visible;
  height: 178px;
}
@media screen and (max-width: 480px) {
  .note-embed {
    float:none;
    margin: 10px 0px;
  }
}
.pamphlet {
  padding:10px 15px;
}
.pamphlet p {
  font-weight:700;
  text-align:center;
}
.box5 {
  border:2px solid #a6a6a6;
  padding:5px 14px;
  background:#FFF 0% 0% no-repeat padding-box;
  right:9px;
  bottom:27px;
  width:500px;
  min-width:170px;
  display:flex;
  justify-content:center;
  align-items:center;
  margin:0 auto;
}
.box5 p {
  font-size:20px;
  font-weight:600;
  color:#000;
  margin:0;
  padding:0;
}
.arrow01 {
  display:block;
  width:12px;
  height:12px;
  border-top:solid 3px #7E7474;
  border-right:solid 3px #7E7474;
  -webkit-transform:rotate(45deg);
  transform:rotate(45deg);
  position:absolute;
  right:34%;
}
@media screen and (max-width: 560px) {
  .box5 {
    width:330px;
  }
  .arrow01 {
    position:static;
  }
}
@media screen and (max-width: 960px) {
  .arrow01 {
    right:29%;
  }
}
@media screen and (min-width: 1280px) {
  .box5 {
    width:600px;
  }
}
.table_container {
  padding:2% 4% 4% 4%;
}
.table {
  white-space:pre-line;
}
table td {
  width:70%;
}
.table_title {
  color:#000000;
  font-size:32px;
  font-weight:bold;
  padding-bottom:20px;
}
.entry {
  padding:2% 4% 4% 4%;
  color:#303030;
}
.entry-contents {
  padding:10px 15px;
}
.entry p {
  font-weight:500;
}
.entry-image {
  text-align:center;
}
img {
  border:3px solid #00AAEB;
  border-radius:50px;
  width:300px;
  height:60px;
  margin:20px 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/RecruitNewgrads.vue